import { notification } from 'antd';
import { all, call, put, take } from 'redux-saga/effects';
import {
  LOAD_ORGANISATION_LIST,
  LOAD_ORGANISATION_DETAIL,
  LOAD_COMPANY_SITE_LIST,
  LOAD_COMPANY_SITE_DETAIL,
} from '../type';
import {
  loadOrganisationListSuccessAction,
  loadOrganisationListErrorAction,
  loadOrganisationDetailSuccessAction,
  loadOrganisationDetailErrorAction,
  loadCompanySiteListSuccessAction,
  loadCompanySiteListErrorAction,
  loadCompanySiteDetailSuccessAction,
  loadCompanySiteDetailErrorAction,
} from '../action';

import { organisationService } from 'services';

function* loadOrganisationList() {
  while (1) {
    const action = yield take(LOAD_ORGANISATION_LIST);
    try {
      const listOrganisation = yield call(
        organisationService.loadOrganisationList,
        action.payload,
      );
      yield put(loadOrganisationListSuccessAction(listOrganisation));
    } catch (err) {
      yield put(loadOrganisationListErrorAction(err));
      notification.error({
        message: err.message,
      });
    }
  }
}

function* loadOrganisationDetail() {
  while (1) {
    const action = yield take(LOAD_ORGANISATION_DETAIL);
    try {
      const organisationDetail = yield call(
        organisationService.loadOrganisationDetail,
        action.payload,
      );
      yield put(loadOrganisationDetailSuccessAction(organisationDetail));
    } catch (err) {
      yield put(loadOrganisationDetailErrorAction(err));
      notification.error({
        message: err.message,
      });
    }
  }
}

function* loadCompanySiteDetail() {
  while (1) {
    const action = yield take(LOAD_COMPANY_SITE_DETAIL);
    try {
      const organisationDetail = yield call(
        organisationService.loadPOSiteDetail,
        action.payload,
      );
      yield put(loadCompanySiteDetailSuccessAction(organisationDetail));
    } catch (err) {
      yield put(loadCompanySiteDetailErrorAction(err));
      notification.error({
        message: err.message,
      });
    }
  }
}

function* loadCompanySiteList() {
  while (1) {
    const action = yield take(LOAD_COMPANY_SITE_LIST);
    try {
      const companySiteList = yield call(
        organisationService.loadCompanySiteList,
        action.payload,
      );
      yield put(loadCompanySiteListSuccessAction(companySiteList));
    } catch (err) {
      yield put(loadCompanySiteListErrorAction(err));
      notification.error({
        message: err.message,
      });
    }
  }
}

export default function* rootSaga() {
  yield all([
    loadOrganisationList(),
    loadCompanySiteList(),
    loadOrganisationDetail(),
    loadCompanySiteDetail(),
  ]);
}
